// extracted by css-extract-rspack-plugin
export default {"section":"Releases-module__section__zuVaYjw","count":"Releases-module__count__mwjSDZ6"};